/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getMVPMetrics = /* GraphQL */ `query GetMVPMetrics($mvp_id: String!) {
  getMVPMetrics(mvp_id: $mvp_id) {
    mvp_id
    visitors
    savings
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMVPMetricsQueryVariables,
  APITypes.GetMVPMetricsQuery
>;
export const listMVPMetrics = /* GraphQL */ `query ListMVPMetrics(
  $filter: TableMVPMetricsFilterInput
  $limit: Int
  $nextToken: String
) {
  listMVPMetrics(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      mvp_id
      visitors
      savings
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMVPMetricsQueryVariables,
  APITypes.ListMVPMetricsQuery
>;
export const getCompanies = /* GraphQL */ `query GetCompanies($company_id: String!, $company_type: String!) {
  getCompanies(company_id: $company_id, company_type: $company_type) {
    company_id
    company_type
    email
    headquarters
    name
    phone
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompaniesQueryVariables,
  APITypes.GetCompaniesQuery
>;
export const listCompanies = /* GraphQL */ `query ListCompanies(
  $filter: TableCompaniesFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      company_id
      company_type
      email
      headquarters
      name
      phone
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompaniesQueryVariables,
  APITypes.ListCompaniesQuery
>;
export const getComplaints = /* GraphQL */ `query GetComplaints($complaint_id: String!, $company_type: String!) {
  getComplaints(complaint_id: $complaint_id, company_type: $company_type) {
    company_type
    complaint_id
    complaint
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetComplaintsQueryVariables,
  APITypes.GetComplaintsQuery
>;
export const listComplaints = /* GraphQL */ `query ListComplaints(
  $filter: TableComplaintsFilterInput
  $limit: Int
  $nextToken: String
) {
  listComplaints(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      company_type
      complaint_id
      complaint
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListComplaintsQueryVariables,
  APITypes.ListComplaintsQuery
>;
export const getSubmissions = /* GraphQL */ `query GetSubmissions($submissionId: String!) {
  getSubmissions(submissionId: $submissionId) {
    submissionId
    company_id
    complaints
    name
    email
    phone
    dateOccurred
    generatedEmail
    timestamp
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubmissionsQueryVariables,
  APITypes.GetSubmissionsQuery
>;
export const listSubmissions = /* GraphQL */ `query ListSubmissions(
  $filter: TableSubmissionsFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubmissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      submissionId
      company_id
      complaints
      name
      email
      phone
      dateOccurred
      generatedEmail
      timestamp
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubmissionsQueryVariables,
  APITypes.ListSubmissionsQuery
>;
